import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** Mirrored arrows across a vertical axis — the image-preview "flip horizontal" control. */
const IconFlipHorizontal: React.FC<IconProps> = ({
  size = 18,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M12 3v18" stroke="currentColor" strokeWidth="1.6" strokeDasharray="2 2" />
    <path d="M9 7 4 12l5 5V7ZM15 7l5 5-5 5V7Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export default IconFlipHorizontal;
